import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useClasses(data = {}) {
  const { enabled = false, queryParams = '', classID } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getClassDetails() {
    return privateFetch.get(`/v1/admin/class/${classID}${queryParams}`).then((res) => res.data);
  }

  return useQuery(['class-details', classID, { data }], getClassDetails, { enabled });
}

export default useClasses;
